import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { device } from "../styled";

const SalonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  width: 90%;
  border: 2px #fff solid;
  border-radius: 10px;
  box-shadow: 0 0 5px 0 rgba(255, 255, 255, 0.676),
    0 10px 30px 0 rgba(255, 255, 255, 0.08);

  a {
    text-decoration: none;
  }

  @media ${device.tablet} {
    width: 500px;
  }
`;

const AddressCity = styled.p`
  margin: 0;
  font-size: 1.1em;
  font-weight: bold;
`;

const AddressStreet = styled.p`
  font-style: italic;
  margin: 0 0 10px 0;
  font-size: 0.9em;
`;

const PhoneNumber = styled.p`
  font-size: 0.8em;
  margin: 10px 0 0 0;
`;

const OpeningHours = styled.p`
  font-size: 0.9em;
  margin: 0;
`;
const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin: 0 3px;
`;

const SalonImageContainer = styled.div`
  width: 50%;
  margin-right: -1px;
`;

const SalonImage = styled.img`
  border-radius: 0 8px;
  width: 100%;
  margin-right: 10px;
  border-left: 2px #fff solid;
  border-bottom: 2px #fff solid;
  box-shadow: 0 0 8px 0 rgba(255, 255, 255, 0.676),
    0 10px 30px 0 rgba(255, 255, 255, 0.08);
`;

const ContentContainer = styled.div`
  margin: auto;
  text-align: start;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 9vh;

  a {
    @media ${device.tablet} {
      width: 30%;
    }
  }
`;

const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin: 10px 0;
  border: 0px;
  border-radius: 8px;
  background-color: #008080;
  color: #fff;
  font-size: 1em;
  font-weight: 600;
`;

const StyledIcon = styled.img`
  width: 20px;
`;

const SalonCard = ({
  city,
  street,
  openinHoursWeekdays,
  phoneNumber,
  salonImage,
  openinHoursWeekends,
  googleMapUrl,
  reservationUrl,
  openinHoursWeekdaysOne,
  openinHoursWeekdaysTwo,
}) => {
  return (
    <SalonContainer>
      <InfoContainer>
        <ContentContainer>
          <AddressCity>{city}</AddressCity>
          <AddressStreet>{street}</AddressStreet>
          <OpeningHours>{openinHoursWeekdays}</OpeningHours>
          <OpeningHours>{openinHoursWeekdaysOne}</OpeningHours>
          <OpeningHours>{openinHoursWeekdaysTwo}</OpeningHours>
          <OpeningHours>{openinHoursWeekends}</OpeningHours>
          <PhoneNumber>{phoneNumber}</PhoneNumber>
        </ContentContainer>
        <SalonImageContainer>
          <SalonImage src={salonImage} />
        </SalonImageContainer>
      </InfoContainer>

      <ButtonContainer>
        <Link to={`tel:${phoneNumber}`}>
          <StyledButtonContainer>
            <StyledIcon src="/tel.png" />
            Csörögj
          </StyledButtonContainer>
        </Link>

        <Link to={googleMapUrl}>
          <StyledButtonContainer>
            <StyledIcon src="/gps.png" />
            Útvonal
          </StyledButtonContainer>
        </Link>
        <Link to={reservationUrl}>
          <StyledButtonContainer>
            <StyledIcon src="/reserve.png" />
            Foglalj
          </StyledButtonContainer>
        </Link>
      </ButtonContainer>
    </SalonContainer>
  );
};

export default SalonCard;
